import {Row, Space, Button, Col, Form, Select, message} from "antd";
import React, {useEffect, useState} from "react";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {medicalSuppliesService} from "api";
import Notification from "components/common/notification/notification";
import {tabKeys} from "types/enums";

const StoreOfUser = () => {
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [options, setOptions] = useState<any[]>([]);
  const activeTab = useAppSelector(state => state.common.activeTab);

  useEffect(() => {
    const khoVTYTQuanLy = JSON.parse(
      localStorage.getItem("khoVTYTQuanLyLocal")
    );
    if (khoVTYTQuanLy) {
      form.setFieldValue("storeManageVTYT", khoVTYTQuanLy);
    }
  }, []);
  useEffect(() => {
    if (activeTab == tabKeys.MEDICAL_SUPPLIES_STORE.CATALOG) {
      getList();
    }
  }, [activeTab]);
  const getList = async () => {
    try {
      const res = await medicalSuppliesService.getListSuppliesStore({
        isKhoAo: "false",
      });
      setOptions(
        res.data.map(e => ({
          value: e.id,
          label: e.name,
        }))
      );
    } catch (error) {
      setOptions([]);
    }
  };
  const submit = async () => {
    await form.validateFields();
    const storeManageVTYT = form.getFieldValue("storeManageVTYT");
    // console.log(storeManageVTYT);
    localStorage.setItem("khoVTYTQuanLyLocal", JSON.stringify(storeManageVTYT));
    Notification("success", "Đã chọn kho quản lý của user");
  };
  return (
    <Space
      direction="vertical"
      className="Store container"
      style={{width: "100%"}}
    >
      <Row justify={"space-between"}>
        <Col>
          {" "}
          <div className="title">Cấu hình kho quản lý</div>{" "}
        </Col>
        <Col>
          <Button type="primary" htmlType="submit" onClick={submit}>
            Lưu lại
          </Button>
        </Col>
      </Row>
      <Row>
        <Form
          form={form}
          style={{maxWidth: "600px", width: "100%"}}
          wrapperCol={{xs: 14, md: 16, lg: 16}}
          labelCol={{xs: 10, md: 8, lg: 8}}
          labelAlign="left"
          placeholder="Chọn kho"
        >
          <Form.Item
            name="storeManageVTYT"
            label="Kho quản lý"
            rules={[{required: true, message: "Chưa chọn kho quản lý"}]}
          >
            <Select
              allowClear
              showSearch
              style={{
                width: "100%",
              }}
              filterOption={(input, option) =>
                (option?.label.toString().toLowerCase() ?? "").includes(
                  input.toLowerCase()
                )
              }
              options={options}
              labelInValue={true}
            ></Select>
          </Form.Item>
        </Form>
      </Row>
    </Space>
  );
};
export default StoreOfUser;
